import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import { take } from 'redux-saga/effects';
import detectFraud from '../../../fraud/nudata';
import globals from '../../../globals/globals';
import * as actions from '../actions';
export var watchNudataDetectFraud = /*#__PURE__*/regeneratorRuntime.mark(function watchNudataDetectFraud() {
  var _yield$take, payload, uri, sessionId, placementValue;

  return regeneratorRuntime.wrap(function watchNudataDetectFraud$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 9;
            break;
          }

          _context.next = 3;
          return take(actions.NUDATA_DETECT_FRAUD);

        case 3:
          _yield$take = _context.sent;
          payload = _yield$take.payload;
          uri = payload.uri, sessionId = payload.sessionId, placementValue = payload.placementValue;
          detectFraud({
            uri: uri,
            sessionId: sessionId,
            placementValue: placementValue,
            isNative: globals().nativeWrapped
          });
          _context.next = 0;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, watchNudataDetectFraud);
});